
if (!customElements.get('home-claim')) {
  class HomeClaim extends HTMLElement {
    constructor() {
      super();
      this.imgSrc = this.dataset.imgSrc || '';
      if (!this.imgSrc) return;

      this.text = this.querySelector('.js-text') || null;
      this.heading = this.querySelector('.js-home-claim-trigger') || null;
      this.textWrapper = this.querySelector('.js-text-wrapper') || null;
      this.productImage = this.querySelector('.js-product-image') || null;
    }
    
    imgSrc = null
    resizeTimeout = null
    heading = null
    text = null
    textWrapper = null

    connectedCallback() {
      this.processUnderlines();
    }

    processUnderlines() {
      const spans = this.text.querySelectorAll('span[style*="text-decoration:underline"], a');
      spans.forEach(span => {
        const image = document.createElement('img');
        image.src = this.imgSrc;
        image.style.setProperty('clip-path', 'inset(0px 100% 0px 0px)');
        span.appendChild(image);
      });

      const images = this.text.querySelectorAll('img');

      if (typeof gsap !== 'undefined') {

        gsap.registerPlugin(ScrollTrigger)

        const tl = gsap.timeline(
          {
            scrollTrigger: {
              trigger: this,
              start: 'top bottom-=10%',
              once: true,
              // markers: true
              onComplete: () => {
                // console.log('onComplete')
                tl.scrollTrigger.refresh()
              }
            }
          }
        );

        tl.fromTo(this.heading, { opacity: 0, yPercent: 20 }, { opacity: 1, yPercent: 0, duration: 0.6 });
        tl.fromTo(this.text, { opacity: 0, yPercent: 20 }, { opacity: 1, yPercent: 0, duration: 0.6 });

        tl.fromTo(images, 
          {
            clipPath: 'inset(0px 100% 0px 0px)',
          },
          {
            clipPath: 'inset(0px 0% 0px 0px)',
            duration: 0.5,
            stagger: 0.55,
            ease: 'power2.out',
          }
        )

        const tlPin = gsap.timeline(
          {
            scrollTrigger: {
              trigger: this,
              start: 'top top',
              end: 'top top-=100%',
              scrub: .4,
              // markers: true,
              onEnter: () => {
                tlPin.scrollTrigger.refresh()
              },
              onLeaveBack: () => {
                tlPin.scrollTrigger.refresh()
                gsap.set(this.textWrapper, {opacity: 1})
              }
            }
          }
        );

        tlPin.fromTo(
          this.textWrapper,
          {
            opacity: 1,
          },
          {
            opacity: 0,
          }
        );

      }
    }
  }
  customElements.define('home-claim', HomeClaim);
}
